import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/app/App'
import { ThemeProvider, applyThemeToDocument, resolveInitialTheme } from '@/app/providers/theme-provider'
import '@/styles/index.css'

applyThemeToDocument(resolveInitialTheme())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)
